module.exports = __webpack_public_path__ + "static/media/Team 13 logo - Frances Morris.cccf6cf5.png";